// extracted by mini-css-extract-plugin
export default {"divider":"courseList_divider__CWO8Q","eachCollapse":"courseList_eachCollapse__GkPZs","deleteBtn":"courseList_deleteBtn__LSWF0","deleteBlock":"courseList_deleteBlock__KS48y"};